module.exports = __webpack_public_path__ + "img/credit_small_icon.88368b5b.svg";